"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var ToolIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("path", { fill: "currentColor", d: "M18.3839 7.19125C18.3784 7.18577 17.2677 8.2843 15.0573 10.4923L13.5064 8.94049L16.811 5.63393C15.0719 4.58658 12.8378 4.85527 11.3891 6.30475C10.8354 6.85851 10.4369 7.54821 10.2336 8.30469C10.0303 9.06118 10.0294 9.85784 10.231 10.6148L10.2638 10.7373L5.08494 15.9173C4.97169 16.0307 4.97169 16.2171 5.08494 16.3304L7.668 18.915C7.78126 19.0283 7.96759 19.0283 8.08085 18.915L13.2561 13.7367L13.3785 13.7696C14.9075 14.1772 16.5498 13.7532 17.6897 12.6126C19.1401 11.1631 19.4087 8.9277 18.3839 7.19125Z" }))); };
exports.ToolIcon = ToolIcon;
